import { Component, OnInit } from '@angular/core';
import {AuthServiceService} from '../services/auth-service.service';


@Component({
  selector: 'cintas-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private authServiceService:AuthServiceService) { }

  ngOnInit() {
  }

  onSubmit(loginForm){
    console.log(loginForm)
    this.authServiceService.login(loginForm);
  }



}
